attachEvent('.menu__arrow', 'click', (el) => {
  const item = el.target.closest('.menu__item');
  const dropdown = item.querySelector('.menu__dropdown');
  if (dropdown) {
    item.classList.toggle('is-open-submenu');
    slideToggle(dropdown, 300, 'block');
  }
});
